export const JWT_KEY = "accessToken" as const
export const JWT_REFRESH_KEY = "refreshToken" as const
